<template>
  <NuxtLoadingIndicator color="#a10009" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <BaseNeuroExpert v-if="false && $route.path.startsWith('/teacher')" />
</template>

<script setup>
useHead({
  meta: [
    {
      name: 'yandex-verification',
      content: '11144a10495e8abe',
    },
    // {
    //   name: 'google-site-verification',
    //   content: '7846hSEAoVBUHll6gRR_wqq_sqhOtyLi9yUs3UiUUIU',
    // },
  ],
});
</script>
